import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getDocs, query, collection, where, limit } from 'firebase/firestore';
import { db } from '../firebaseConfig';

const withMetaTags = () => {
  const MetaTagsContext = React.createContext({ title: document.title });

  const MetaTagsProvider = ({ children }) => {
    const [tags, setTags] = useState({ title: document.title });

    useEffect(() => {
      const { hostname: domain } = window.location;

      if (
        !['app.ruttl.com', 'staging.ruttl.com', 'localhost'].includes(domain)
      ) {
        const q = query(
          collection(db, 'teams'),
          where('domain', '==', domain),
          limit(1),
        );

        (async () => {
          try {
            const querySnapshot = await getDocs(q);

            if (querySnapshot.docs.length) {
              const { name } = querySnapshot.docs[0].data();

              setTags({ title: name });
            }
          } catch (e) {
            /* */
          }
        })();
      }
    }, []);

    return (
      <MetaTagsContext.Provider value={tags}>
        {children}
      </MetaTagsContext.Provider>
    );
  };

  MetaTagsProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };

  const useMetaTags = () => useContext(MetaTagsContext);

  return { MetaTagsProvider, useMetaTags };
};

export const { MetaTagsProvider, useMetaTags } = withMetaTags();
